<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'GettingStarted',

    metaInfo: { title: 'Getting Started' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        // 'platform-support',
        // 'customer-reviews',
        // 'we-help-your-success',
        // 'info-graph',
        // 'theme-features',
        // 'affiliates',
        'getting-started',
        // 'newsletter',
        'info-alt',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
